import { connect } from 'react-redux';
import { PasswordSettings as PasswordSettingsContent } from './PasswordSettings';
import {
  clearChangePassword,
  onChangeOldPassword,
  onChangeNewPassword,
  onChangeConfirmPassword,
  handleChangePasswordShow,
  onSubmitChangePassword,
  updateProfileRoute,
} from '../../../../actions/profile';

const mapStateToProps = ({ user, changePasswordForm, profile }) => ({
  user,
  changePasswordForm,
  profile,
});

export const PasswordSettings = connect(mapStateToProps, {
  clearChangePassword,
  onChangeOldPassword,
  onChangeNewPassword,
  onChangeConfirmPassword,
  handleChangePasswordShow,
  onSubmitChangePassword,
  updateProfileRoute,
})(PasswordSettingsContent);
